import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { form } from '../assets/styles/utility';
import { generateUUID } from '../helpers/utility';
import FormControlWrapper from './FormControlWrapper';
import Icon, { StylesIconVariables } from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesInputBase = (theme, props = {}) => [form.base(theme), {
  //  Remove default style in browsers that support `appearance`
  appearance: 'none'
}, // Apply default form styling, except for `file`, `submit`, `reset`, `button` and `image`
!['file', 'submit', 'reset', 'button', 'image'].includes(props.type) && form.input(theme, {
  error: props.validationMessage,
  noContrast: props.noContrast
}), // Fix the cursor style for Chrome's increment/decrement buttons. For certain `font-size` values of the `input`, it causes the cursor style of the decrement button to change from `default` to `text`.
props.type === 'number' && {
  '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
    height: 'auto'
  }
}, // Remove inner padding and search cancel button in Chrome, Safari and Opera on OS X.
props.type === 'search' && {
  '&::-webkit-search-cancel-button, &::-webkit-search-decoration': {
    appearance: 'none'
  }
}, {
  // 1. Correct the inability to style clickable types in iOS and Safari.
  // 2. Change font properties to `inherit` in Safari.
  '&::--webkit-file-upload-button': {
    appearance: 'button',
    // 1
    font: 'inherit' // 2

  },
  // Remove clear button in IE on inputs
  '&::ms-clear': {
    display: 'none'
  },
  // Removes `box-shadow` for invalid controls in Firefox.
  '&:invalid': {
    boxShadow: 'none'
  }
}, props.prefixIcon && {
  paddingLeft: "calc(" + (form.variables(theme).padding + theme.space.small) + "px + " + StylesIconVariables.base + ")"
}];

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "65loc0-Input",
  styles: "position:relative;label:Input;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    disabled,
    label,
    name,
    noContrast,
    type,
    validationMessage,
    explanationMessage,
    prefixIcon,
    required,
    wrapperProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "disabled", "label", "name", "noContrast", "type", "validationMessage", "explanationMessage", "prefixIcon", "required", "wrapperProps"]);

  const theme = useTheme(); // Only regenerate this if the name prop changes

  const id = React.useMemo(() => name + "-" + generateUUID(), [name]);
  return ___EmotionJSX(FormControlWrapper, _extends({
    required: required,
    label: label,
    labelProps: {
      htmlFor: id
    },
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }, wrapperProps), ___EmotionJSX("div", {
    css: _ref2
  }, prefixIcon && ___EmotionJSX("div", {
    css: [{
      color: theme.fontColor.muted,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: form.variables(theme).padding,
      zIndex: 2,
      opacity: disabled && theme.opacity.base,
      pointerEvents: 'none'
    }, theme.settings.contrast.enable && theme.settings.contrast.form && !noContrast && {
      '.u-contrast &': {
        color: theme.contrast.muted
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Input;"]
  }, ___EmotionJSX(Icon, {
    icon: prefixIcon
  })), ___EmotionJSX("input", _extends({
    css: StylesInputBase(theme, {
      type,
      prefixIcon,
      validationMessage,
      noContrast
    }),
    className: clsx('CK__Input', className),
    name: name,
    id: id,
    ref: ref,
    type: type,
    disabled: disabled
  }, rest))));
});
Input.defaultProps = {
  type: 'text'
};
export default Input;